import axios from 'axios'
import i18n from '@/i18n/index.js'

const http = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
    headers: {Accept: 'application/json'}
})
http.interceptors.request.use(config => {
    config.params = config.params || {}
    if (!config.params['lang']) {
        config.params['lang'] = i18n.global.locale.value
    }
    return config
})

export {
    http
}